import { useEffect, useState } from 'react';

/**
 * v1.18.0 — KYC completion progress, same "animate fill on first mount"
 * treatment as FundingProgressBar (components/investments/FundingProgressBar.jsx):
 * starts at width 0 and flips to the real percentage one tick later so the
 * CSS transition has something to animate. Accepts a precomputed `percent`
 * rather than raw fields — kycApi.js's normalizeKycProgress is the single
 * source of truth for the underlying 50/50 math (identity + "other" tags),
 * this component just renders whatever it's given.
 */
export default function KycProgressBar({ percent = 0, label = 'KYC completion' }) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setWidth(clamped));
    return () => cancelAnimationFrame(raf);
  }, [clamped]);

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <p className="text-sm font-medium text-foreground">{label}</p>
        <p className="text-sm font-semibold text-accent">{clamped}%</p>
      </div>
      <div className="h-2.5 rounded-full bg-background-elevated overflow-hidden">
        <div
          className="h-full rounded-full accent-gradient transition-all duration-700 ease-out"
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}
